import { reportingDashboardConstants } from "../_constants";

const {
  GET_ALL_REPORTS_START,
  GET_ALL_REPORTS_SUCCESS,
  GET_ALL_REPORTS_FAILED,
  ADD_REPORT_START,
  ADD_REPORT_END,
  ADD_REPORT_FAILED,
  VIEW_REPORT_START,
  VIEW_REPORT_SUCCESS,
  VIEW_REPORT_FAILED,
  EDIT_REPORT_START,
  EDIT_REPORT_END,
  EDIT_REPORT_SUCCESS,
  EDIT_REPORT_FAILED,
  FILTER_REPORT_START,
  FILTER_REPORT_SUCCESS,
  FILTER_REPORT_FAILED,
} = reportingDashboardConstants;

const initialState = {
  reports: [],
  currentReport: null,
  isGetAllReportsLoading: false,
  isAddReportLoading: false,
  isViewReportLoading: false,
  isEditReportLoading: false,
  getAllReportsError: null,
  addReportError: null,
  viewReportError: null,
  editReportError: null,
  reportCount: 0,
  reportSuccess: 0,
  reportFailed: 0,
  reportPending: 0,
  reportUnprocessed: 0
};

const ReportsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_REPORTS_START:
      return {
        ...state,
        isGetAllReportsLoading: true,
      };
    case GET_ALL_REPORTS_SUCCESS:
      const { content, count, success, failed, pending, unProcessed } = payload;
      return {
        ...state,
        isGetAllReportsLoading: false,
        reports: content,
        reportCount: count,
        reportSuccess: success,
        reportFailed: failed,
        reportPending: pending,
        reportUnprocessed: unProcessed
      };
    case GET_ALL_REPORTS_FAILED:
      return {
        ...state,
        isGetAllReportsLoading: false,
        getAllReportsError: payload,
      };
    case ADD_REPORT_START:
      return {
        ...state,
        isAddReportLoading: true,
        addReportError: null,
      };
    case ADD_REPORT_END:
      return {
        ...state,
        isAddReportLoading: false,
      };
    case ADD_REPORT_FAILED:
      return {
        ...state,
        isAddReportLoading: false,
        addReportError: payload,
      };
    case VIEW_REPORT_START:
      return {
        ...state,
        isViewReportLoading: true,
        viewReportError: null,
      };
    case VIEW_REPORT_SUCCESS:
      return {
        ...state,
        isViewReportLoading: false,
        currentReport: payload,
      };
    case VIEW_REPORT_FAILED:
      return {
        ...state,
        isViewReportLoading: false,
        viewReportError: payload,
      };
    case EDIT_REPORT_START:
      return {
        ...state,
        isEditReportLoading: true,
        editReportError: null,
      };
    case EDIT_REPORT_END:
      return {
        ...state,
        isEditReportLoading: false,
      };
    case EDIT_REPORT_FAILED:
      return {
        ...state,
        isEditReportLoading: false,
        editReportError: payload,
      };
    case EDIT_REPORT_SUCCESS:
      return {
        ...state,
        isEditReportLoading: false,
        currentReport: payload,
      };
    case FILTER_REPORT_START:
      return { ...state, isGetAllReportsLoading: true };
    case FILTER_REPORT_SUCCESS:
      const { content: filterReportData, count: filterReportCount, success: filteredReportSuccessCount, failed: filteredReportFailedCount, pending: filteredReportPendingCount, unProcessed: filteredReportUnprocessedCount } = payload;
      return {
        ...state,
        isGetAllReportsLoading: false,
        reports: filterReportData,
        reportCount: filterReportCount,
        reportSuccess: filteredReportSuccessCount,
        reportFailed: filteredReportFailedCount,
        reportPending: filteredReportPendingCount,
        reportUnprocessed: filteredReportUnprocessedCount
      };
    case FILTER_REPORT_FAILED:
      return {
        ...state,
        isGetAllReportsLoading: false,
        error: payload,
      };
    default:
      return state;
  }
};

export default ReportsReducer;
